import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en";
import hi from "./locales/hi";

// Flatten the namespace structure for backward compatibility
const flattenTranslations = (translations: Record<string, any>) => {
  const flattened: Record<string, any> = {};

  // Keep all namespaces available as separate resources
  Object.keys(translations).forEach((ns) => {
    if (typeof translations[ns] === "object") {
      // Add namespace content to main translation
      Object.keys(translations[ns]).forEach((key) => {
        flattened[`${ns}.${key}`] = translations[ns][key];
        // Also add without namespace for backward compatibility
        if (ns === "common" || ns === "navigation") {
          flattened[key] = translations[ns][key];
        }
      });
    }
  });

  return flattened;
};

const resources = {
  hi: {
    translation: flattenTranslations(hi),
    // Keep namespaces available
    ...hi,
  },
  en: {
    translation: flattenTranslations(en),
    // Keep namespaces available
    ...en,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "hi", // default language
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
  defaultNS: "translation",
  fallbackNS: "translation",
});

export default i18n;
